export const KLAVIYO_PUBLIC_API_KEY = "Syateq"
